import React from 'react'
import styled from 'styled-components'
import { BaseButton } from '../Section'

const PrimaryBtn = styled(BaseButton)`
	background: #373636;
	color:#fff;	
	& .icon{
		> svg{
			fill:#fff;
		}
	}	
	&:before {
		background:#E9242A;
	}
`
const PrimaryButton = (props) => {
	const { icon, iconAfter, text, size } = props;
	return(
		<PrimaryBtn className={`btn ${size ? `btn-${size}` : ''} `}>
			{ iconAfter ? (
				<>
					{ text && <span className='text'>{text}</span>}
					{ iconAfter && <span className='icon'>{iconAfter}</span>}
				</>
				):(
					<>
						{ icon && <span className='icon'>{icon}</span>}
						{ text && <span className='text'>{text}</span>}
					</>
				)
			}
		</PrimaryBtn>
	)
}


export default PrimaryButton

